export default {
  namespaced: true,
  assigned_video_tours: {
    title: "Assigned Video Tours",
    single: "assigned Video Tours",
    all: "all assigned Video Tours",

    current_assignment: "current assignment",
    schedule_video_tours: "schedule Video Tours",
    change: "change",
    change_now: "change now",

    video_tour: "video tour",
    video_tours: "Video Tours",
    sector: "sector",
    sectors: "sectors",

    analyst: "analyst",
    supervisor: "supervisor",
    change_supervisor: "change supervisor",
    change_video_tours: "change Video Tours",

    scheduled: "scheduled",
    programmed: "scheduled",
    manual_change: "manual change",

    init_date: "start date",
    end_date: "end date",
    active_at: "active at",
    active_at_help: "Filter assignments active at a specific date and time.",
    since: "since",

    select_supervisor: "select a supervisor",
    select_sector: "select a video tour",
    select_sectors: "select video tours",
    select_analyst: "select an analyst",

    supervisor_optional: "Supervisor is optional.",
    no_supervisor: "no supervisor assigned",
    no_video_tours: "no assigned video tours",

    effective_assignment: "effective assignment",
    assignment_history: "assignment history",
    programmed_assignment: "scheduled assignment",
    current_supervisor: "current supervisor",
    current_video_tours: "current video tours",

    save_programmed: "save scheduled assignment",
    save_change: "save change",

    messages: {
      created: "Assignment created successfully.",
      updated: "Assignment updated successfully.",
      deleted: "Assignment deleted successfully.",
      changed: "Assignment changed successfully.",
      closed: "Current override closed successfully.",
      load_error: "Error loading assignments.",
      save_error: "Error saving assignment.",
      delete_error: "Error deleting assignment.",
      change_error: "Error changing assignment.",
      required_supervisor: "Please select a supervisor.",
      required_video_tours: "Please select at least one video tour.",
    },
  },
};
